import React from "react";
import { PropTypes } from "prop-types";
import {
    UserPodcastExpirationCell,
    UserListEmptyState,
} from "administration/user/components";
import { MrbGrid } from "mrb/components/grid";
import { MrbQuerySearchInput } from "mrb/components/input";
import { MrbLineContentLoader } from "mrb/components/loader";

function UserPodcastExpirationTemplate({ userPodcastExpirationViewStore, t }) {
    const { gridStore, queryUtility } = userPodcastExpirationViewStore;
    return (
        <div>
            <div className="u-mar--bottom--sml">
                <MrbQuerySearchInput
                    queryUtility={queryUtility}
                    showSearchButton={false}
                />
            </div>
            <MrbGrid
                emptyStateRender={UserListEmptyState}
                loaderRender={() => (
                    <MrbLineContentLoader
                        setWidth={1024}
                        lineheight={60}
                        setY={68}
                        rows={10}
                        backgroundColor={"#33363B"}
                        foregroundColor={"#393C42"}
                    />
                )}
                classNameOverride="c-card--list"
                store={gridStore}
                t={t}
                cellRender={(props) => (
                    <UserPodcastExpirationCell
                        userPodcastExpirationViewStore={
                            userPodcastExpirationViewStore
                        }
                        {...props}
                    />
                )}
            />
        </div>
    );
}

UserPodcastExpirationTemplate.propTypes = {
    userPodcastExpirationViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default UserPodcastExpirationTemplate;
